import { Pipe, PipeTransform } from '@angular/core';
import { MissionPlace } from '../../models/mission/mission-place';

@Pipe({
	name: 'filterMissionPlaceByAllFields'
})
export class FilterMissionPlaceByAllFieldsPipe implements PipeTransform {
	transform(missionPlaces: MissionPlace[], filter: string): MissionPlace[] {
		if (
			missionPlaces === null ||
			!missionPlaces ||
			!filter ||
			filter === null ||
			filter === ''
		) {
			return missionPlaces;
		}

		filter = filter.toLowerCase();
		return missionPlaces.filter(
			(missionPlace) =>
				missionPlace.specialties?.some((spe) =>
					spe.name.toLowerCase().includes(filter)
				) ||
				missionPlace.name.toLowerCase().includes(filter) ||
				missionPlace.nameDisplay.toLowerCase().includes(filter) ||
				missionPlace.address.label.toLowerCase().includes(filter)
		);
	}
}
